module.exports = __webpack_public_path__ + "images/home_pic_right-c9a6e43ae1.png";